export default {
  ENDPFOSTEN: 1285,
  ECKPFOSTEN: 1283,
  MITTELPFOSTEN: 1268,
  BARRIERE: 2222,
  BARRIERE_1500: 2223,
}